// node_modules
import { FC } from 'react';

export const NotFound: FC = () => {
    return (
        <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
            <p>Looks like you got lost in IGOR^AI.</p>
        </div>
    );
};
